import { useEffect, useState } from "react";
import { formatCents, parseCents } from "@shared/money";
import { TextField, type TextFieldProps } from "./TextField";

export type MoneyFieldProps = Omit<TextFieldProps, "value" | "onChange" | "type" | "prefix"> & {
  /** Integer cents; null when empty. */
  value: number | null;
  onChange: (cents: number | null) => void;
};

const toText = (cents: number | null) => (cents === null ? "" : formatCents(cents).replace("$", ""));

/** Dollar input that stores integer cents (SPEC §4); decimal keyboard on phones. */
export function MoneyField({ value, onChange, ...rest }: MoneyFieldProps) {
  const [text, setText] = useState(toText(value));
  useEffect(() => {
    if (parseCents(text) !== value) setText(toText(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return (
    <TextField
      {...rest}
      prefix="$"
      inputMode="decimal"
      value={text}
      onChange={(e) => {
        setText(e.target.value);
        onChange(e.target.value.trim() === "" ? null : parseCents(e.target.value));
      }}
      onBlur={() => setText(toText(value))}
    />
  );
}
